import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box, CircularProgress, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import AppColor from "utilities/AppColor";

const useStyles = makeStyles(() => ({
  answersContainer: {
    marginTop: 12,
    paddingTop: 12,
    borderTop: "1px dashed #E5E7EB",
  },
  pw: { 
    background: "#F0FDF9", 
    border: "1px solid #99F6E4", 
    borderRadius: 8, 
    padding: 12, 
    marginBottom: 10, 
  },
  pq: { 
    fontSize: 13, 
    fontWeight: 600, 
    color: "#0F766E", 
    marginBottom: 7, 
    display: "flex", 
    alignItems: "center", 
    gap: 6, 
  },
  pnum: { 
    width: 18, 
    height: 18, 
    borderRadius: "50%", 
    background: AppColor.mainColor, 
    color: "#fff", 
    fontSize: 9, 
    fontWeight: 700, 
    display: "flex", 
    alignItems: "center", 
    justifyContent: "center", 
    flexShrink: 0, 
  },
  contentInner: { 
    background: "#fff",
    border: "1px solid #D1FAF5",
    borderRadius: 6,
    padding: 9,
  },
  answerDisplay: {
    fontSize: 13,
    color: "#0F766E",
    padding: "4px 0",
  },
  answerPill: {
    display: "inline-flex",
    alignItems: "center",
    padding: "5px 12px",
    borderRadius: 999,
    background: AppColor.mainColor,
    color: "#fff",
    fontSize: 12,
    fontWeight: 500,
  },
  detailSection: {
    marginTop: 8,
    paddingTop: 8,
    borderTop: "1px dashed #D1FAF5",
  },
  detailText: {
    fontSize: 13,
    color: "#0F766E",
    lineHeight: 1.5,
  },
  loadingBox: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    color: "#6B7280",
    padding: "12px 0",
  },
  emptyBox: {
    textAlign: "center",
    color: "#9CA3AF",
    fontSize: 13,
    padding: "20px 0",
    fontStyle: "italic",
  },
}));

const ProgressNoteAnswersList = ({ answers, loading, t }) => {
  const classes = useStyles();
  const { t: translation } = useTranslation();

  if (loading) {
    return (
      <Box className={classes.loadingBox}>
        <CircularProgress size={18} />
        <Typography style={{ fontSize: 13 }}>
          {translation("message.loading_answers")}
        </Typography>
      </Box>
    );
  }

  if (!answers || answers.length === 0) {
    return (
      <Box className={classes.emptyBox}>
        {translation("message.no_detailed_answers")}
      </Box>
    );
  }

  return (
    <Box className={classes.answersContainer}>
      {answers.map((ans, index) => (
        <Box key={ans.id || index} className={classes.pw}>
          {/* Question Header */}
          <Box className={classes.pq}>
            <Box className={classes.pnum}>{index + 1}</Box>
            {ans.questionText}
          </Box>

          {/* Worker Info */}
          {(ans.workerName || ans.formattedDate) && (
            <Box display="flex" justifyContent="space-between" mb={1} alignItems="center">
              <Typography style={{ fontSize: 13, fontWeight: 700, color: "#111827" }}>
                {ans.workerName}
              </Typography>
              <Typography style={{ fontSize: 12, color: "#6B7280" }}>
                {ans.formattedDate}
              </Typography>
            </Box>
          )}

          {/* Content */}
          <Box className={classes.contentInner}>
            {/* Answer */}
            <Box className={classes.answerPill}>
              {
                ans.answer?.toUpperCase() === "YES" || ans.answer?.toUpperCase() === "NO"
                  ? translation(`button.${ans.answer?.toLowerCase()}`)
                  : ans.answer
              }
            </Box>

            {/* Detail */}
            {ans.detail && ans.detail.trim() && (
              <Box className={classes.detailSection}>
                <Typography className={classes.detailText}>
                  {ans.detail}
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default ProgressNoteAnswersList;
